import * as TackNotificationsActions from '../tack_notifications/actions';
import * as PeopleNotificationsActions from '../people_notifications/actions';
import * as TrendsActions from '../trends/actions';
import * as FeedActions from '../feed/actions';
import * as SubscriptionActions from '../subscriptions/actions';

export const processMessageFromMobileApp = (messageEvent, loggedIn) => {
  return (dispatch) => {
    try {
      if (messageEvent.data && messageEvent.data.toString().trim().length > 0) {
        const payload = JSON.parse(messageEvent.data);
        if (loggedIn && payload.mobileAppFocused) {
          dispatch(TackNotificationsActions.unreadCount());
          dispatch(PeopleNotificationsActions.unreadCount());
          dispatch(TrendsActions.newest());
          dispatch(TrendsActions.mostTacked());
          dispatch(FeedActions.followsFeed());
        } else if (payload.mobilePaymentSupported) {
          dispatch(SubscriptionActions.toggleMobilePaymentSupported(payload.mobilePaymentSupported, payload.mobilePaymentMethod));
        } else if (payload.processMobilePayment) {
          dispatch(SubscriptionActions.processMobilePayment(payload.paymentToken));
        }
      }
    } catch (error) {
      //Think about how to handle these later. For now, I have enough trust we can parse JSON when we need to.
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/intra_app_messaging_receiver/actions.js